import { createAction } from "@reduxjs/toolkit";
import type { AdminBatchDetailVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveAdminBatchDetail = createApiThunk<AdminBatchDetailVM, string>(
  "admin/batch/retrieve",
  async (id, { extra: { adminRepository } }) => {
    return adminRepository!.getBatchDetail(id);
  },
);

export const resetRetrieveAdminBatchDetail = createAction("admin/batch/resetRetrieve");
